import type { StyledCreditCardInputProps } from '../StyledStripeInput';
import { StyledStripeInput } from '../StyledStripeInput';

export type CreditCardCvcProps = Omit<
  StyledCreditCardInputProps<'cardCvc'>,
  'type'
>;

/**
 * Render a Credit Card CVC field. Must be child of {@link StripeProvider} and
 * {@link StripeElementsProvider}.
 */
export function CreditCardCvc(props: CreditCardCvcProps) {
  return <StyledStripeInput type="cardCvc" {...props} />;
}
